import styled from 'styled-components'
import { theme } from '../../style/theme'
import { ButtonWrapper } from '../Elements/buttons/Button/style/buttonWrap/index.styled'

export const FilterWrapper = styled.div`
	padding: 0;
	margin: 1.87em 0 1.25em;
`
export const FilterForm = styled.div`
	width: 100%;
	display: grid;

	gap: 1.25em;
	grid-template-columns: 10.3em repeat(4, minmax(7.85em, 14.38em)) auto;

	${ButtonWrapper} {
		min-height: 3.12em;
		width: 100%;
	}

	> label:last-child {
		justify-self: end;
		min-height: 3.12em;
	}

	@media screen and (max-width: ${theme.point820}) {
		grid-template-columns: 1fr 1fr;
		gap: 1.43em 0.72em;

		> label:last-child {
			justify-self: auto;
			min-height: 3.93em;
		}

		${ButtonWrapper} {
			min-height: 3.93em;
		}
	}

	@media screen and (max-width: ${theme.point520}) {
		grid-template-columns: 1fr;
		gap: 1.25em;
	}
`

export const BadgesWrapper = styled.div`
	padding-top: 1em;
	margin-bottom: 1em;
	display: block;

	&.toggled {
		display: none;
		padding-top: 0;
		margin-bottom: 0;
	}
`

BadgesWrapper.displayName = 'BadgesWrapper'
